import { Injectable } from '@angular/core';
import { NbToastrService } from '@nebular/theme';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ToggleHide, ToggleShow } from 'src/app/shared/ui/spinner/redux/spinner.actions';
import { SmartCleanService } from '../../services/smart-clean.service';
import { CleanScoreStateModel } from './clean-score-state.model';
import {
  LoadSmartCleanRecords,
  LoadSmartCleanRecordsFail,
  LoadSmartCleanRecordsSuccess,
  PatchCleanScore,
  PatchCleanScoreFail,
  PatchCleanScoreSuccess,
  RemoveCleanScore
} from './clean-score.actions';

@State<CleanScoreStateModel>({
  name: 'smartCleanRecord',
  defaults: {
    smartCleanRecords: [],
    error: null
  }
})
@Injectable()
export class CleanScoreState {
  constructor(private service: SmartCleanService, private toastrService: NbToastrService) {}

  @Selector()
  public static smartCleanRecords(state: CleanScoreStateModel) {
    return state.smartCleanRecords;
  }

  @Action(LoadSmartCleanRecords)
  public async loadSmartCleanRecords(ctx: StateContext<CleanScoreStateModel>, { payload }: any) {
    ctx.dispatch(ToggleShow);
    this.service.loadSmartCleanRecordsAmplify(payload);
  }

  @Action(LoadSmartCleanRecordsSuccess)
  public loadSmartCleanRecordsSuccess(ctx: StateContext<CleanScoreStateModel>, { payload }: any) {
    const state = ctx.getState();
    const newCleanRecordsState = state.smartCleanRecords.concat(payload);

    ctx.setState({
      ...state,
      smartCleanRecords: newCleanRecordsState
    });
    ctx.dispatch(ToggleHide);
  }

  @Action(LoadSmartCleanRecordsFail)
  public loadSmartCleanRecordsFail(ctx: StateContext<CleanScoreStateModel>, { payload }: any) {
    this.toastrService.show(status, $localize`Fetching Smart Clean Record Failed: ${payload}`, {
      status: 'danger'
    });
    ctx.dispatch(ToggleHide);
  }

  @Action(PatchCleanScore)
  public async patchCleanScore(ctx: StateContext<CleanScoreStateModel>, { payload }: any) {
    ctx.dispatch(ToggleShow);
    if (payload.pmap_id) {
      this.service.patchCleanScoreAmplify(payload);
    } else {
      this.service.patchCleanScoreP2mapAmplify(payload);
    }
  }

  @Action(PatchCleanScoreSuccess)
  public async patchCleanScoreSuccess(ctx: StateContext<CleanScoreStateModel>, { payload }: any) {
    this.toastrService.show(status, $localize`Update: Complete`, { status: 'success', preventDuplicates: true });
    ctx.dispatch(ToggleHide);
  }

  @Action(PatchCleanScoreFail)
  public async PatchCleanScoreFail(ctx: StateContext<CleanScoreStateModel>, { payload }: any) {
    this.toastrService.show(status, $localize`Patching Clean Score Record Failed: ${payload}`, {
      status: 'danger'
    });
    ctx.dispatch(ToggleHide);
  }

  @Action(RemoveCleanScore)
  public async removeCleanScores(ctx: StateContext<CleanScoreStateModel>, { payload }: any) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      smartCleanRecords: []
    });
    ctx.dispatch(ToggleHide);
  }
}
